import PropTypes from "prop-types";
import { FaCheck } from "react-icons/fa";
import { getTourIcon } from "./tourIcons";

export const TourStepTitle = ({ stepId, title }) => {
    const Icon = getTourIcon(stepId);

    return (
        <div className="product-tour-title-row">
            <span className="product-tour-title-icon" aria-hidden="true">
                <Icon size={16} />
            </span>
            <span>{title}</span>
        </div>
    );
};

TourStepTitle.propTypes = {
    stepId: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};

export const TourStepCover = ({ stepId, kicker, variant }) => {
    const Icon = getTourIcon(stepId);

    return (
        <div className={`product-tour-cover${variant === "finish" ? " product-tour-cover--finish" : ""}`}>
            <div className="product-tour-cover-icon" aria-hidden="true">
                <Icon size={30} />
            </div>
            {kicker ? <p className="product-tour-cover-kicker">{kicker}</p> : null}
        </div>
    );
};

TourStepCover.propTypes = {
    stepId: PropTypes.string.isRequired,
    kicker: PropTypes.string,
    variant: PropTypes.oneOf(["welcome", "finish"]),
};

export const TourStepBody = ({ greeting, description, highlights, tip, tipLabel }) => (
    <div>
        {greeting ? <p className="product-tour-greeting">{greeting}</p> : null}
        <p className="product-tour-desc">{description}</p>
        {Array.isArray(highlights) && highlights.length > 0 ? (
            <ul className="product-tour-highlights">
                {highlights.map((item) => (
                    <li key={item}>
                        <FaCheck className="product-tour-highlights-icon" size={11} aria-hidden="true" />
                        <span>{item}</span>
                    </li>
                ))}
            </ul>
        ) : null}
        {tip ? (
            <div className="product-tour-tip">
                <span className="product-tour-tip-label">{tipLabel}</span>
                <span>{tip}</span>
            </div>
        ) : null}
    </div>
);

TourStepBody.propTypes = {
    greeting: PropTypes.string,
    description: PropTypes.string.isRequired,
    highlights: PropTypes.arrayOf(PropTypes.string),
    tip: PropTypes.string,
    tipLabel: PropTypes.string,
};
